<script>
// 新建客户
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { alertError, successMsg } from "@/helpers/swal";
import { postCustomer } from "@/service";
import { CUSTOMER_INDUSTRY_LIST, CUSTOME_ATTR_LIST, COMPANY_SIZE, LEVEL_ATTR_LIST } from "@/config/common";
import datePickr from "@/views/widgets/date-pickr";
import LocationSelect from "@/views/widgets/location-select";
import i18n from "@/i18n";
import { WO_OODT_ASSETS } from '@/config/common';
import _ from "lodash";

import {
  // country, 
  // city,
  province
} from "@/service";
import axios from "axios";

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.create')
    }
  },
  data() {
    return {
      showModal: false,
      logo: 0,
      form: {},
      waitFormat: null,//
      city_data: {},
      INDUSTRY: CUSTOMER_INDUSTRY_LIST,
      CUSTOME_ATTR_LIST,
      COMPANY_SIZE,
      LEVEL_ATTR_LIST
    }
  },
  validations: {
    form: {
      name: { required },
      attribute: { required },
      address: { required },
      email: { email },
    }
  },
  watch: {},
  methods: {
    open() {
      this.formInit()
      this.showModal = true
    },
    formInit() {
      this.form = {
        logo: null,
        name: null,
        tel: null,
        ka_level: null,
        email: null,
        industry: null,
        home_url: null,
        build_at: null,
        size: null,
        province: null,
        city: null,
        country: null,
        address: null,
        introduce: null,
        attribute: null,
        code: null,
        extra: null,//客户城市的经纬度，格式：{"coordinate":[1,2]}
      }
    },
    /* 拼接后端存储的城市json文件请求地址 */
    assetsURLMap(province) {
      const baseURL = _.trimEnd(_.trim(WO_OODT_ASSETS, '"'), "/")
      let pro = province
      if (province.includes("省") || province.includes("市")) {
        pro = province.replace("省", "").replace("市", "")
      }
      // let pro_ = encodeURI(encodeURI(pro))
      return `${baseURL}/oodt-assets/map/${pro}.json`
    },
    async save() {
      if (this.waitFormat) {
        this.getLocationName(this.waitFormat)
      }
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      // if (!this.form.logo) {
      //   alertError('提示', '请上传logo！')
      //   return
      // }
      for (let i = 0; i < this.v$.form.email.$errors.length; i++) {
        if (this.v$.form.email.$errors[i].$message == 'Value is not a valid email address') {
          alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
          return
        }
      }
      if (!result) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      if(this.form.attribute==='KA'&&!this.form.ka_level){
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      } 
      setTimeout(()=>{
        console.log("请求的数据：", this.form);
        postCustomer(this.form).then(res => {
          if (![200, 201].includes(res.meta.code)) {
            alertError(this.$t('base.prompt'), res.meta.message)
            return
          }
          successMsg(this.$t('page.Customer_creation_success'))
          this.showModal = false
          this.$emit('refresh')
        }).catch(err => {
          alertError(this.$t('base.prompt'), this.$t('page.errorOccurred'))
          console.log(err)
        })
      },1000)

    },
    locationSelected(selected) {
      if (selected) {
        this.form.country = selected[0]
        this.form.province = selected[1]
        this.form.city = selected[2]
        this.waitFormat = selected
      } else {
        this.form.country = null
        this.form.province = null
        this.form.city = null
        this.waitFormat = null
      }
    },
    /* 城市转换经纬度 */
    makePoint(data, city, address) {
      let reslut = { coordinate: [] }
      // console.log(data, city, address);

      if (city in this.city_data) {
        let {
          lat_max,
          lat_min,
          lng_max,
          lng_min,
          p
        } = this.city_data[city]

        let lat_range = lat_max - lat_min;
        let lng_range = lng_max - lng_min;
        for (var j = 0; j < 1; j++) {
          var x = 0;
          var y = 0;
          for (var i = 0; i < 100; i++) {
            x = (lng_min * 100) / 100 + (Math.random() * lng_range);
            y = (lat_min * 100) / 100 + (Math.random() * lat_range);


            if (this.isPointInsidePolygon([x, y], this.formatArr(p))) {
              // console.log("Point1:", [x, y])
              reslut.coordinate = [x, y]
            }
          }
        }
      } else {

        let feature = null;
        for (var a = 0; a < data.features.length; a++) {
          if (data.features[a].properties.name == city) {
            feature = data.features[a]
            break
          }
        }

        if (!feature && address) {
          for (var f = 0; f < data.features.length; f++) {
            if (address.indexOf(data.features[f].properties.name.replace("区", "")) != -1) {
              feature = data.features[f]
              break
            }
          }
        }

        if (!feature) {
          let i = parseInt(Math.random() * (data.features.length - 1))
          feature = data.features[i]
        }

        if (!feature) {
          console.log(city + "-not found")
          return
        }
        var coordinates = feature.geometry.coordinates

        var temp = []
        for (var ii = 0; ii < coordinates.length; ii++) {
          for (var jj = 0; jj < coordinates[ii].length; jj++) {
            var length = coordinates[ii][jj].length
            if (length > temp.length) {
              temp = coordinates[ii][jj]
            }
          }
        }

        let lat_max = 0;
        let lat_min = 360;
        let lng_max = 0;
        let lng_min = 360;

        var p = []
        temp.forEach(n => {
          lng_max = n[0] > lng_max ? n[0] : lng_max;
          lng_min = n[0] < lng_min ? n[0] : lng_min;

          lat_max = n[1] > lat_max ? n[1] : lat_max;
          lat_min = n[1] < lat_min ? n[1] : lat_min;
          // p.push(new window.BMap.Point(n[0], n[1]))
          p.push([n[0], n[1]])
        });

        if (city != "重庆市" && city != "天津市" && city != "北京市" && city != "上海市") {
          this.city_data[city] = {
            lat_max,
            lat_min,
            lng_max,
            lng_min,
            p
          }
        }

        let lat_range = lat_max - lat_min;
        let lng_range = lng_max - lng_min;
        for (var flag = 0; flag < 1; flag++) {

          var x_ = 0;
          var y_ = 0;

          for (var s = 0; s < 100; s++) {
            x_ = (lng_min * 100) / 100 + (Math.random() * lng_range);
            y_ = (lat_min * 100) / 100 + (Math.random() * lat_range);



            // if (window.BMapLib.GeoUtils.isPointInPolygon(pt, ply)) {
            if (this.isPointInsidePolygon([x_, y_], p)) {
              // console.log("Point2",[x_, y_])
              reslut.coordinate = [x_, y_]
            }
          }
        }
      }
      this.form.extra = reslut
      return reslut;
    },
    async getLocationName(selected) {
      let reslut = ['中国']
      try {
        // //省份
        // let data_province = null,
        // province = null
        await province({ page_size: 0, country: selected[0] }).then(res => {
          let info = res.payload && res.payload.find(item => item.id == selected[1])
          if (info) {
            // province = info.name
            reslut.push(info.name)
            axios.get(this.assetsURLMap(info.name)).then(res => {
              // data_province = res.data
              this.makePoint(res.data, info.name, this.form.address)
            })
          } else {
            reslut.push(null)
          }
        })
        //城市
        // await city({ page_size: 0, country: selected[0], province: selected[1] }).then(res => {
        //   let info = res.payload && res.payload.find(item => item.id == selected[2])
        //   if (info) {
        //     reslut.push(info.name)
        //     if (data_province) {
        //       this.makePoint(data_province, province, this.form.address)
        //     }
        //   } else {
        //     reslut.push(null)
        //   }
        // })
      } catch (error) {
        reslut = []
      }
    },

    // 
    isPointInsidePolygon(point, vertices) {
      const x = point[0];
      const y = point[1];

      let inside = false;
      for (let i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
        const xi = vertices[i][0];
        const xj = vertices[j][0];
        const yi = vertices[i][1];
        const yj = vertices[j][1];

        const intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }

      return inside;// 如果在多边形内返回true，否则返回false
    },
    formatArr(arr) {
      let list = []
      arr.map(item => {
        list.push([item.lng, item.lat])
      })
      return list;
    }
  },
  components: {
    uploadAvatar,
    datePickr,
    LocationSelect,
  }
}
</script>
<template>
  <b-modal v-model="showModal" hide-footer :title="title" class="v-modal-custom" body-class="p-0" scrollable centered
    size="lg">
    <div class="modal-body border-top" style="max-height: 60vh;">
      <div class="logo-wraper d-flex justify-content-center mb-3">
        <upload-avatar v-model="form.logo" input-id="uploadLogo" filename-prefix="sc" return-type="url"></upload-avatar>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('serviceCompany.company_name') }}<span
            class="text-danger">{{ this.$t('serviceCompany.not_null') }}</span></label>
        <input type="text" class="form-control" :class="v$.form.name.$errors.length ? 'is-invalid' : ''"
          :placeholder="this.$t('serviceCompany.company_name')" v-model="form.name" @blur="v$.form.name.$touch()"
          required />
      </div>

      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.industry') }}</label>
        <Multiselect class="form-control" :can-clear="false" :can-deselect="false" v-model="form.industry"
          :close-on-select="true" :searchable="true" :create-option="false"
          :placeholder="this.$t('page.select-industry')" :options="INDUSTRY" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('base.attribute') }}<span
            class="text-danger">{{ this.$t('serviceCompany.not_null') }}</span></label>
        <Multiselect :class="v$.form.attribute.$errors.length ? 'is-invalid' : ''" class="form-control"
          :can-clear="false" :can-deselect="false" v-model="form.attribute" :close-on-select="true" :searchable="true"
          :create-option="false" :placeholder="this.$t('page.PleaseSelectProperties')" :options="CUSTOME_ATTR_LIST" />
      </div>
      <div v-if="form.attribute === 'KA'" class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{  $t("KA客户类型") }}<span
            v-if="form.attribute === 'KA' && !form.ka_level"
            class="text-danger">{{ this.$t('serviceCompany.not_null') }}</span></label>
        <Multiselect class="form-control" :class="form.attribute === 'KA' && !form.ka_level ? 'is-invalid' : ''"
          :can-clear="false" :can-deselect="false" v-model="form.ka_level" :close-on-select="true" :searchable="true"
          :create-option="false" :placeholder="this.$t('page.PleaseSelectProperties')" :options="LEVEL_ATTR_LIST" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.customer-attr.code') }}</label>
        <input type="text" class="form-control" :placeholder="this.$t('page.customer-attr.code')" v-model="form.code" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title"
          for="meta-keywords-input">{{ this.$t('page.work-order.contact-phone') }}</label>
        <input type="text" class="form-control" :placeholder="this.$t('page.work-order.contact-phone')"
          v-model="form.tel" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.email') }}</label>
        <input type="text" class="form-control" :class="v$.form.email.$errors.length ? 'is-invalid' : ''"
          :placeholder="this.$t('page.email')" v-model="form.email" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.homepage') }}</label>
        <input type="text" class="form-control" :placeholder="this.$t('page.homepage')" v-model="form.home_url" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.establishedTime') }}</label>
        <date-pickr class="w-100" v-model="form.build_at" :placeholder="this.$t('page.establishedTime')"></date-pickr>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.companySize') }}</label>
        <Multiselect class="form-control" :can-clear="false" :can-deselect="false" v-model="form.size"
          :close-on-select="true" :searchable="true" :create-option="false" :placeholder="this.$t('page.companySize')"
          :options="COMPANY_SIZE" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.companyAddress') }}<span
            class="text-danger">{{ this.$t('serviceCompany.not_null') }}</span></label>
        <div class="w-100">
          <location-select @selected="locationSelected"></location-select>
          <input type="text" class="form-control mb-3" :class="v$.form.address.$errors.length ? 'is-invalid' : ''"
            :placeholder="this.$t('page.detailedAddress')" v-model="form.address" />
        </div>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ this.$t('page.companyIntroduction') }}</label>
        <b-form-textarea class="form-control" rows="5" max-rows="8" :placeholder="this.$t('page.companyIntroduction')"
          v-model="form.introduce"></b-form-textarea>
      </div>
    </div>

    <div class="modal-footer v-modal-footer" style="padding-right: 20px;padding-bottom: 20px;">
      <b-button type="button" variant="light" @click="showModal = false">{{ this.$t('base.cancel') }}
      </b-button>
      <b-button type="button" variant="primary" @click="save">{{ this.$t('base.done') }}</b-button>
    </div>
  </b-modal>
</template>
<style scoped>
.field-title {
  width: 300px;
}

.multiselect {
  padding: 0 0.9rem;
}

:deep(.multiselect-wrapper) {
  position: unset;
}
</style>
